import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './Header.scss';

const CodeEditorTitle = ({ theme }) => {
  const { t } = useTranslation('common');
  const isDarkTheme = theme === 'vs-dark';

  return (
    <div
      className={classNames({
        [styles['white-text']]: isDarkTheme,
        [styles['black-text']]: !isDarkTheme,
        [styles.headerLeft]: true,
      })}
      style={{ fontSize: '16px' }}
    >
      {t('editor.code_editor_title')}
    </div>
  );
};

export default CodeEditorTitle;
